<script lang="ts" setup>
import { ref, computed } from 'vue'
import ElFormOrganization from '../settings/components/ElForm/ElFormOrganization.vue'
import { useAuth, useOrganizations } from 'auth-package'

interface Props {
    modelValue: boolean
    organizationUUId?: string
    isEdit?: boolean
}

const props = defineProps<Props>()

const emit = defineEmits(['update:modelValue'])

const showDialog = computed({
    get: () => {
        if (props.modelValue != null) {
            return props.modelValue
        } else {
            return ''
        }
    },
    set: (value) => {
        if (value != null) {
            emit('update:modelValue', value)
        } else {
            emit('update:modelValue', '')
        }
    }
})

const organizationForm = ref<InstanceType<typeof ElFormOrganization>>()

/**
 * Creates a new organization.
 * If the request is successful, it closes the dialog.
 * @returns {Promise<void>}
 */
async function createOrganization() {
    const response = await organizationForm.value?.onSubmit()

    if (response) {
        showDialog.value = false
    }
}
</script>

<template>
    <el-dialog
        :title="$t('settings.createOrganization')"
        v-model="showDialog"
        append-to-body
        destroy-on-close
    >
        <ElFormOrganization ref="organizationForm" />
        <template #footer>
            <el-button type="primary" @click="createOrganization()">
                {{ $t('settings.create') }}
            </el-button>
        </template>
    </el-dialog>
</template>

<style lang="scss" scoped></style>
